export const API_WARNINGS = {
  minimum_stay_required: {
    title: 'Minimum length of stay restriction.',
    message: 'Try selecting different dates to load rate details.',
  },
}
